module.exports = __webpack_public_path__ + "static/media/white_house_phone.8f3b76bb.png";